import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {
  Button,
  CircularProgress,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  OutlinedInput,
  MenuItem,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { PutAPI } from "../../Components/Backend/PutAPI";
import PageTitle from "../../Components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import PageSubTitle from "../../Components/Layout/PageSubTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Backdrop from "@mui/material/Backdrop";

export default function ComputerUpdate() {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(5); // Computadores
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  <Backdrop
  sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={loading}
>
  <CircularProgress color="inherit" />
</Backdrop>
  
  const apiAxios = APIAxios();
  const { id } = useParams();
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(""); // NOVO
  const [log, setLog] = useState([]);

  const [formData, setFormData] = useState({
    pk: { id: 0, idEmpresa: 0 },
    descricao: "",
    recebeAlertas: "",
    token: "",
    regMouse: "",
    tempoMouse: "",
    regPrograma: "",
    tempoPrograma: "",
    regImagem: "",
    tempoImagem: "",
    regInternet: "",
    tempoInternet: "",
    regTeclado: "",
    tempoTeclado: "",
    espacoUtilizado: "",
    ultimoLog: [],
  });

  {/*Tipografia para tabela de log*/}
  const theme = createTheme({
    typography: {
      fontFamily: '"Courier New", Courier, monospace',
    },
  });

  const navigate = useNavigate();

  // Função para formatar bytes em KB, MB ou GB
  const formatarBytes = (bytes) => {
    if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
    if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(2)} MB`;
    return `${(bytes / 1024).toFixed(2)} KB`;
  };

  const formatarUsoEspaco = (usado, total) => {
    const percentual = ((usado / total) * 100).toFixed(2);
    return `${formatarBytes(usado)}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      setAvisoErro("");
      setLoading(true);

      const response = await GetAPI(apiAxios, `/computador/${id}`);
      setLoading(false);
      setAvisoErro(response.errorMessage);

      if (response.success) {
        setFormData(response.data);
        setColaboradorSelecionado(response.data.idColaborador);
      } else {
        setFormData({
          pk: { id: 0, idEmpresa: 0 },
          descricao: "",
          recebeAlertas: "",
          token: "",
          regMouse: "",
          tempoMouse: "",
          regPrograma: "",
          tempoPrograma: "",
          regImagem: "",
          tempoImagem: "",
          regInternet: "",
          tempoInternet: "",
          regTeclado: "",
          tempoTeclado: "",
          idColaborador: 0,
          espacoUtilizado: "",
        });
      }
    };
    fetchData();
  }, []);

  const handleListarUltimos = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    const response = await GetAPI(apiAxios, `/ultimos/${id}`);
    setLoading(false);

    if (!response.success) {
      setAvisoErro(response.errorMessage);
    } else {
      setLog(response.data);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setAvisoErro("");
    setAvisoSucesso("");

    try {
      const registro = {
        pk: { id: formData.pk.id, idEmpresa: formData.pk.idEmpresa },
        descricao: formData.descricao,
        recebeAlertas: formData.recebeAlertas,
        token: formData.token,
        regMouse: formData.regMouse,
        tempoMouse: formData.tempoMouse,
        regPrograma: formData.regPrograma,
        tempoPrograma: formData.tempoPrograma,
        regImagem: formData.regImagem,
        tempoImagem: formData.tempoImagem,
        regInternet: formData.regInternet,
        tempoInternet: formData.tempoInternet,
        regTeclado: formData.regTeclado,
        tempoTeclado: formData.tempoTeclado,
        idColaborador: colaboradorSelecionado,
        remover: formData.remover,
        espacoUtilizado: formData.espacoUtilizado,
      };
      const response = await PutAPI(apiAxios, "/computador", registro);

      if (response.success) {
        setAvisoSucesso("Computador atualizado com sucesso.");
      } else {
        setAvisoErro("Erro ao atualizar o computador.");
      }
    } catch (error) {
      setAvisoErro(error.message);
    } finally {
      setLoading(false);
    }
  };

  //Busca Colaboradores no backend
  const buscaColaboradores = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, "/colabs");
    setLoading(false);

    if (response.success) {
      setColaboradores(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar colaboradores.");
    }
  };

  useEffect(() => {
    buscaColaboradores();
    handleListarUltimos();
  }, []);

  const handleVoltar = () => {
    navigate("/computadores");
  };

  return (
    <Box>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Alteração de Computadores"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}
      <CssBaseline />
      <Container maxWidth="lg">
        <Box component="main" sx={{ bgcolor: "#fff", minHeight: "80vh" }}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              gap: 2,
              backgroundColor: "transparent",
              borderRadius: 1,
            }}
          >
            <TextField
              label="Código Do Computador"
              name="id"
              type="text"
              disabled
              value={formData.pk.id}
              required
              fullWidth
            />
            <TextField
              label="Descrição do Computador"
              name="descricao"
              type="text"
              value={formData.descricao}
              onChange={handleChange}
              required
              fullWidth
            />

            {/* Select de Colaborador */}
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel id="label-colaborador">Colaborador</InputLabel>
                <Select
                  labelId="label-colaborador"
                  value={colaboradorSelecionado}
                  onChange={(e) => {
                    setColaboradorSelecionado(Number(e.target.value));
                  }}
                  input={<OutlinedInput label="Colaborador" />}
                >
                  {(colaboradores ?? []).map((colab) => (
                    <MenuItem key={colab.id} value={String(colab.id)}>
                      {colab.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={9}>
                <TextField
                  label="Token"
                  name="token"
                  type="text"
                  value={formData.token}
                  onChange={handleChange}
                  required
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl component="fieldset" required fullWidth>
                  <FormLabel component="legend">Recebe Alertas</FormLabel>
                  <RadioGroup
                    row
                    name="recebeAlertas"
                    value={formData.recebeAlertas}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="S"
                      control={
                        <Radio checked={formData.recebeAlertas === "S"} />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="N"
                      control={
                        <Radio checked={formData.recebeAlertas === "N"} />
                      }
                      label="Não"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <FormControl component="fieldset" required>
                  <FormLabel component="legend">Registro do Mouse</FormLabel>
                  <RadioGroup
                    row
                    name="regMouse"
                    value={formData.regMouse}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="S"
                      control={<Radio checked={formData.regMouse === "S"} />}
                      label="Sim"
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio checked={formData.regMouse === "N"} />}
                      label="Não"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={9}>
                <TextField
                  label="Tempo do Mouse"
                  name="tempoMouse"
                  type="number"
                  value={formData.tempoMouse}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 4) handleChange(event);
                  }}
                  required
                  fullWidth
                  inputProps={{ maxLength: 4 }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <FormControl component="fieldset" required>
                  <FormLabel component="legend">Registro de Programa</FormLabel>
                  <RadioGroup
                    row
                    name="regPrograma"
                    value={formData.regPrograma}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="S"
                      control={<Radio checked={formData.regPrograma === "S"} />}
                      label="Sim"
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio checked={formData.regPrograma === "N"} />}
                      label="Não"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={9}>
                <TextField
                  label="Tempo do Programa"
                  name="tempoPrograma"
                  type="number"
                  value={formData.tempoPrograma}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 4) handleChange(event);
                  }}
                  required
                  fullWidth
                  inputProps={{ maxLength: 4 }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <FormControl component="fieldset" required>
                  <FormLabel component="legend">Registro de Teclado</FormLabel>
                  <RadioGroup
                    row
                    name="regTeclado"
                    value={formData.regTeclado}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="S"
                      control={<Radio checked={formData.regTeclado === "S"} />}
                      label="Sim"
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio checked={formData.regTeclado === "N"} />}
                      label="Não"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={9}>
                <TextField
                  label="Tempo do Teclado"
                  name="tempoTeclado"
                  type="number"
                  value={formData.tempoTeclado}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 4) handleChange(event);
                  }}
                  required
                  fullWidth
                  inputProps={{ maxLength: 4 }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <FormControl component="fieldset" required>
                  <FormLabel component="legend">Registro de Imagem</FormLabel>
                  <RadioGroup
                    row
                    name="regImagem"
                    value={formData.regImagem}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="S"
                      control={<Radio checked={formData.regImagem === "S"} />}
                      label="Sim"
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio checked={formData.regImagem === "N"} />}
                      label="Não"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={9}>
                <TextField
                  label="Tempo da Imagem"
                  name="tempoImagem"
                  type="number"
                  value={formData.tempoImagem}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 4) handleChange(event);
                  }}
                  required
                  fullWidth
                  inputProps={{ maxLength: 4 }}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                variant="contained"
                type="submit"
                disabled={loading}
                onClick={handleVoltar}
                sx={{ backgroundColor: "#1a3865" }}
              >
                Voltar
              </Button>
              <Button
                variant="contained"
                type="submit"
                disabled={loading}
                sx={{ backgroundColor: "#1a3865" }}
              >
                {loading ? "Atualizando..." : "Atualizar Computador"}
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: "#98ADD8",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>

            {/*Sessão Informações de Armazenamento*/}
            <Grid item xs={12} md={12}>
              <PageSubTitle caption="Informações de Armazenamento" />
            </Grid>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <TextField
                  label="Espaço Utilizado"
                  name="espacoUtilizado"
                  type="text"
                  disabled
                  value={formatarUsoEspaco(formData.espacoUtilizado)}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Registro Mais Antigo de Atividade"
                  name="primeiroRegistro"
                  type="text"
                  value={formData.primeiroRegistro ?? ""}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Registro Mais Antigo de Imagem"
                  name="primeiraImagem"
                  type="text"
                  value={formData.primeiraImagem ?? ""}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  disabled
                />
              </Grid>
            </Grid>

            {/*Sessão Histórico de Sistema*/}
            <Box sx={{ mt: 4, mb: 0 }}>
              <PageTitle caption="Histórico de Sistema" accentStyle />
            </Box>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Id</TableCell>
                    <TableCell align="center">Computador</TableCell>
                    <TableCell align="center">Usuário</TableCell>
                    <TableCell align="center">Data e Hora</TableCell>
                    <TableCell align="center">Calendario</TableCell>
                    <TableCell align="center">Colaborador</TableCell>
                    <TableCell align="center">IdEmpresa</TableCell>
                    <TableCell align="center">Type</TableCell>
                  </TableRow>
                </TableHead>
                <ThemeProvider theme={theme}>
                  <TableBody>
                    {log.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center" component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell align="center">{row.computerName}</TableCell>
                        <TableCell align="center">{row.userName}</TableCell>
                        <TableCell align="center">{row.dataHora}</TableCell>
                        <TableCell align="center">{row.idCalendario}</TableCell>
                        <TableCell align="center">
                          {row.idColaborador}
                        </TableCell>
                        <TableCell align="center">{row.idEmpresa}</TableCell>
                        <TableCell align="center">{row.type}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </ThemeProvider>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
